import profile from "./profile.json";
import projects from "./projects.json";
import certifications from "./certifications.json";
import writing from "./writing.json";
import experience from "./experience.json";

const staticContent = { profile, projects, certifications, writing, experience };

export default staticContent;
